import { Group } from "@tine/designsystem-ui-react";
import { cn } from "@tine/designsystem-utils";
import { observer } from "mobx-react-lite";
import BarcodeScannerButton from "../../components/barcodes/BarcodeScannerButton";
import MainColumn from "../../components/common/MainColumn";

import FavoriteListButton from "../../components/FavoriteListButton";
import LoginButton from "../../components/login/LoginButton";
import NewCustomerButton from "../../components/login/NewCustomerButton";
import authStore from "../../stores/auth/authStore";
import theme from "../../themes/theme";
import MiniCart from "../minicart/MiniCart";
import MobileCategories from "./MobileCategories";
import MobileDeliveryInfo from "./MobileDeliveryInfo";

const className = cn(["bg-[--color-base-0]", "w-full"]);

const groupClassName = cn(["my-2", "w-full"]);

const BurgerMenuAndCart = () => (
   <div className={className}>
      <MainColumn>
         <Group align="center" justify="between" className={groupClassName}>
            <MobileCategories />

            <div className="flex items-center justify-end p-0">
               {authStore.isLoggedIn() ? (
                  <>
                     <BarcodeScannerButton className="mx-2" />
                     <FavoriteListButton />
                     <MobileDeliveryInfo />
                  </>
               ) : (
                  <>
                     <LoginButton />
                     {theme.newCustomerForm && <NewCustomerButton />}
                  </>
               )}
               <div className="pl-4">
                  <MiniCart />
               </div>
            </div>
         </Group>
      </MainColumn>
   </div>
);

export default observer(BurgerMenuAndCart);
